import styled from 'styled-components';
import { border } from 'styles/Colors';
import { ReactComponent as SearchIcon } from 'components/icons/search.svg';
import React from 'react';

export const SearchBarWrapper = styled.div`
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid ${border};
  overflow: hidden;
`;

export const SearchIconWrapper = styled.span`
  display: inline-block;
  width: 45px;
`;

export const StyledSearchIcon = styled((props) => <SearchIcon {...props} />)`
  margin: 0 0 2px 7px;
  opacity: 0.24;
  &.active {
    opacity: 1;
  }
`;

export const StyledInput = styled.input`
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  &::placeholder {
    opacity: 0.35;
  }
`;
